import { useState } from "react";
import ModalCobertura from "./modal/ModalCobertura";
import '../styles/Coberturas.css';

const CoberturasCards = ({ cobertura, coberturasDesc }) => {
  const [mostrarModalCobertura, setMostrarModalCobertura] = useState(false);

  return (
    <>
      <ModalCobertura
        show={mostrarModalCobertura}
        close={setMostrarModalCobertura}
        titulo={cobertura.tituloCobertura}
        desc={cobertura.descripcionDesplegada}
        icon={cobertura.ico}
        coberturasDesc={coberturasDesc}
      />

      {/* DESKTOP */}
      <div className="eco__card m-auto d-none d-lg-flex">
        <div>
          <div className="cob__card-img">
            {/* <img className='cob__card-icoprincipal' src={cober.img} alt="imagen cob" /> */}
            <div className="eco__card-ico_container ">
              <img
                className={`eco__card-ico`}
                src={cobertura.ico}
                alt="imagen cob icono"
              />
            </div>
          </div>
          <div className="eco__card-texto mt-3">
            <div className="eco__card-superior">
              <h4
                style={{ textAlign: "left", marginBottom: "1em" }}
                className={`eco__card-title`}
                dangerouslySetInnerHTML={{__html: cobertura.tituloCobertura}}
              >
              </h4>
              <p
                style={{
                  textAlign: "left",
                  fontSize: "1.4rem",
                  lineHeight: "20px",
                  fontFamily: "var(--fuente-regular)",
                }}
                className="eco__card-descripcion"
              >
                {cobertura.descripcion}
              </p>
            </div>
          </div>
        </div>
        <div className="cob__card-btn">
          <div
            className="link__conocemas"
            onClick={() => setMostrarModalCobertura(true)}
          >
            CONOCE MÁS
          </div>
        </div>
      </div>

      {/* MOBILE */}
      <div className="eco__card d-flex d-lg-none">
        <div>
          {/* <img className='cob__card-icoprincipal' src={cober.img} alt="imagen cob" /> */}
          <div className="cob__card-img" style={{ height: "13rem" }}>
            <div className="eco__card-ico_container-mov" style={{marginLeft: "-3rem"}}>
              <img
                className={`eco__card-ico`}
                src={cobertura.ico}
                alt="imagen cob icono"
              />
            </div>
          </div>
          <div className="eco__card-texto">
            <div className="eco__card-superior px-4">
              <h4
                style={{ textAlign: "left", marginBottom: "1em" }}
                className={`eco__card-title`}
                dangerouslySetInnerHTML={{__html: cobertura.tituloCobertura}}
              >
              </h4>
              <p
                style={{
                  textAlign: "left",
                  fontSize: "18px",
                  lineHeight: "30px",
                  fontFamily: "var(--fuente-regular)"
                }}
                className="eco__card-descripcion cober__descripcion"
              >
                {cobertura.descripcion}
              </p>
              <div
                className="modal__group"
                id={cobertura.id}
                style={{ width: "300px", display: "none" }}
              >
                <div className="modal__descripcion">
                  <h3>¿Qué no cubre tu seguro?</h3>
                  <ul className="list__modal">
                    {coberturasDesc.map((item, index) => {
                      return (
                        <li className="d-flex" style={{ textAlign: "left" }}>
                          {item.descripcionCobertura}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cob__card-btn">
          <div
            className="link__conocemas mobile__conocemas"
            // onClick={() => expandCardInfo(cober.id)}
            onClick={() => setMostrarModalCobertura(true)}
          >
            CONOCE MÁS
          </div>
        </div>
      </div>
    </>
  );
};

export default CoberturasCards;
